<template>
  <div class="infoContainer ">
      <div class="menuText">基本信息</div>
      <div class="content">
          <el-form  inline label-position="left" label-width="100px">
                    <el-form-item label="姓名">
                        <el-input size="small" v-model="saleman.name"></el-input>
                    </el-form-item>
                    <el-form-item label="电话">
                        <el-input size="small" v-model="saleman.tel"></el-input>
                    </el-form-item>
                    <el-form-item label="个人邮箱">
                        <el-input size="small" v-model="saleman.email"></el-input>
                    </el-form-item>
                    <el-form-item label="Oland邮箱">
                        <el-input size="small" v-model="saleman.olandEmail"></el-input>
                    </el-form-item>
                    <el-form-item label="居住国家/地区">
                        <el-select size="small" v-model="saleman.live_country"></el-select>
                    </el-form-item>
                    <el-form-item label="居住城市" >
                        <el-select size="small" v-model="saleman.live_city"></el-select>
                    </el-form-item>
                    <el-form-item label="居住地址" class="address">
                        <el-input size="small" v-model="saleman.live_address"></el-input>
                    </el-form-item>
                    <el-form-item label="国家/地区" >
                        <el-select size="small" v-model="saleman.country"></el-select>
                    </el-form-item>
                    <el-form-item label="城市" >
                        <el-select size="small" v-model="saleman.city"></el-select>
                    </el-form-item>
                    <el-form-item label="母语">
                        <el-input size="small" v-model="saleman.language"></el-input>
                    </el-form-item>
                    <el-form-item label="单位">
                        <el-input size="small" v-model="saleman.office"></el-input>
                    </el-form-item>
                    <el-form-item label="证件类型">
                        <el-input size="small" v-model="saleman.cardType"></el-input>
                    </el-form-item>
                    <el-form-item label="证件号">
                        <el-input size="small" v-model="saleman.cardNo"></el-input>
                    </el-form-item>
                    <el-form-item label="银行">
                        <el-input size="small" v-model="saleman.bank"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账号" >
                        <el-input size="small" v-model="saleman.bankNo"></el-input>
                    </el-form-item>

                </el-form>
      </div>
      <div class="menuText">任务信息</div>
      <div class="content">
          <el-form inline label-position="left" label-width="100px">
                <el-form-item label="无反馈" >
                    <el-input size="small" value="200"></el-input>
                </el-form-item>
                <el-form-item label="已下载" >
                    <el-input size="small" value="100"></el-input>
                </el-form-item>
                <el-form-item label="已注册" >
                    <el-input size="small" value="50"></el-input>
                </el-form-item>
                <el-form-item label="已激活" >
                    <el-input size="small" value="30"></el-input>
                </el-form-item>
          </el-form>
      </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex';
import region from '@/components/region';
export default {
  name: 'left',
  data () {
    return {
        saleman: {
                        name: 'oland',
                        tel: '057180888888',
                        email: 'test@163.com',
                        olandEmail: 'support@olandcorp.com',
                        live_country: 'china',
                        live_city: 'hangzhou',
                        live_address: 'wener Road No. 195 Room 302',
                        country: 'china',
                        city: 'shanghai',
                        language: 'japanese',
                        cardType: '身份证',
                        cardNo: '330106199001010003',
                        bank: 'ICBC',
                        bankNo: '620000001341234',
                        office: 'borderless',
                        taskCount: 100
                    }
    }
  },
  mounted: function () {
     this.$nextTick(function () {

     })
  },
  computed: {
        regions() {
          return region;
        },
        cityList() {
          if(this.saleman.country) {
            this.saleman.city = '';
            if(this.regions.city[this.saleman.country]) {
              return this.regions.city[this.saleman.country];
            } else if(this.regions.state[this.saleman.country]) {
                return this.regions.state[this.saleman.country]
            } else {
              return [];

            }
          }
        },
      ...mapState(['menuPath','salesmanUid'])
  },
  methods: {
      getSalesman(){
        this.salesmanUid = 1;
        this.$axios.get('/api/salesman/getSalesman?salesmanUid='+this.salesmanUid).then(res=>{
            console.log(res)
            this.saleman = res.data.saleSalesman;
        })
      },
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.infoContainer .content {padding: 20px 0 20px 30px;}
.infoContainer .el-form-item {width: 40%;}
.infoContainer  .el-form-item input{width: 180px;}
</style>



// WEBPACK FOOTER //
// src/components/Info.vue